import React, { useState, useEffect, useCallback } from 'react'


export const Gallery = () => {
    const images = [
        "https://africantraveltour.com/assets/img/6-days-tanzania-affordable-safari-banner.webp",
        "https://skyrocklabourconsultants.com/assets/img/uganda-destination.jpg",
        "https://skyrocklabourconsultants.com/assets/img/4-days-mt-meru-climbing.jpg",
        "https://skyrocklabourconsultants.com/assets/img/tanzania-destination.jpg",
        "https://skyrocklabourconsultants.com/assets/img/new-wlcm-img-aftt-2.jpg",
        "https://skyrocklabourconsultants.com/assets/img/tanzania-destination-2.jpg"
    ];
    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);

    // Open modal at given image index
    const openAt = (i) => {
        setIndex(i);
        setOpen(true);
    };

    const close = () => setOpen(false);

    const prev = useCallback(() => {
        setIndex((cur) => (cur - 1 + images.length) % images.length);
    }, []);

    const next = useCallback(() => {
        setIndex((cur) => (cur + 1) % images.length);
    }, []);

    // Keyboard navigation
    useEffect(() => {
        if (!open) return;

        const onKey = (e) => {
            if (e.key === "Escape") close();
            if (e.key === "ArrowLeft") prev();
            if (e.key === "ArrowRight") next();
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [open, prev, next]);

    // Prevent body scroll when modal is open
    useEffect(() => {
        document.body.style.overflow = open ? "hidden" : "";
        return () => { document.body.style.overflow = ""; };
    }, [open]);
    return (
         <div style={{
              position: "relative",
              zIndex: 100,
              backgroundImage: "var(--bg-image)",
              backgroundAttachment: "fixed",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}>
              
        
              {/* Hero Section */}
              <div className="container-fluid bg-primary py-5 mb-5 hero-header">
                <div className="container py-5">
                  <div className="row justify-content-center py-5">
                    <div className="col-lg-10 text-center">
                      <h1 className="section-header text-white animated slideInDown mb-4">gallery</h1>
                      <nav aria-label="breadcrumb">
                        <ol className="breadcrumb justify-content-center">
                          <li className="breadcrumb-item"><a href="/">Home</a></li>
                          <li className="breadcrumb-item text-white active" aria-current="page">gallery</li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>





            {/* Gallery Thumbnails */}
            <div className="gallery-root mt-5">
                {images.reduce((rows, img, index) => {
                    if (index % 3 === 0) {
                        // Start a new group with the large image
                        rows.push({
                            large: img,
                            thumbs: images.slice(index + 1, index + 3),
                            startIndex: index
                        });
                    }
                    return rows;
                }, []).map((group, gIndex) => (
                    <div key={gIndex} className="gallery-group mb-4">
                        {/* Large Image */}
                        <div
                            className="top-large"
                            onClick={() => openAt(group.startIndex)}
                            role="button"
                            tabIndex={0}
                        >
                            <img
                            className='img-fluid'
                                src={group.large}
                                alt={`Gallery large ${group.startIndex}`}
                                loading="lazy"
                            />
                            
                        </div>

                        {/* Two Thumbnails */}
                        <div className="bottom-row">
                            {group.thumbs.map((thumb, tIndex) => (
                                <div
                                    key={tIndex}
                                    className="thumb"
                                    onClick={() => openAt(group.startIndex + tIndex + 1)}
                                    role="button"
                                    tabIndex={0}
                                >
                                    <img
                                        src={thumb}
                                        alt={`Gallery thumb ${group.startIndex + tIndex + 1}`}
                                        loading="lazy"
                                        className='img-fluid'
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>


            {/* Modal Carousel */}
            {open && (
                <div className="modal-overlay" onMouseDown={close} role="dialog" aria-modal="true">
                    <div className="modal-content" onMouseDown={(e) => e.stopPropagation()}>
                        <div className="image-wrap">
                            {/* Close button moved to top-right of the image */}
                            <button className="close-btn" onClick={close} aria-label="Close">✕<span className="sr-only">Close</span></button>

                            <img src={images[index]} alt={`Slide ${index + 1}`} />

                            {/* Controls row at bottom-center of the image */}
                            <div className="controls" role="toolbar" aria-label="Carousel controls">
                                <button className="nav small" onClick={prev} aria-label="Previous image">‹</button>
                                <div className="counter">{index + 1} / {images.length}</div>
                                <button className="nav small" onClick={next} aria-label="Next image">›</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Local styles */}
            <style>{`
        .gallery-root {
          max-width: 1100px;
          margin: 0 auto;
          gap: 12px;
        }
        .top-large {
          width: 100%;
          height: 420px;
          overflow: hidden;
          border-radius: 6px;
          position: relative;
          cursor: pointer;
        }
        .top-large img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          transition: transform .35s ease;
        }
        .top-large:hover img { transform: scale(1.03); }
        .play-overlay {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          background: rgba(0,0,0,0.35);
          color: white;
          padding: 10px 14px;
          border-radius: 50%;
          font-size: 22px;
          pointer-events: none;
        }

        .bottom-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
          margin-top: 12px;
        }
        .thumb {
          height: 280px;
          overflow: hidden;
          border-radius: 6px;
          cursor: pointer;
        }
        .thumb img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          transition: transform .35s ease;
        }
        .thumb:hover img { transform: scale(1.05); }

        /* Modal overlay */
        .modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.95);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }
        .modal-content {
          position: relative;
          width: 95%;
          max-width: 1300px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;    
          background-color: transparent;
        }

        /* image-wrap holds the image and the controls/close inside it */
        .image-wrap {
          position: relative;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          max-height: calc(100vh - 120px);
        }
        .image-wrap img {
          max-width: 100%;
          max-height: calc(100vh - 160px);
          object-fit: contain;
          border-radius: 6px;
          display: block;
        }

        /* Close button positioned top-right of image */
        .close-btn {
          position: absolute;
          top: 12px;
          right: 12px;
          background: rgba(0,0,0,0.45);
          border: 0;
          color: white;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          font-size: 18px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          z-index: 6;
        }
        .close-btn:hover { background: rgba(0,0,0,0.6); transform: scale(1.02); }

        /* Controls at bottom center of the image */
        .controls {
          position: absolute;
          bottom: 18px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          align-items: center;
          gap: 14px;
          z-index: 6;
          background: rgba(0,0,0,0.18);
          padding: 8px 12px;
          border-radius: 999px;
          backdrop-filter: blur(6px);
        }

        .nav.small {
          background: transparent;
          border: 2px solid rgba(255,255,255,0.25);
          width: 44px;
          height: 44px;
          border-radius: 50%;
          color: white;
          font-size: 22px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: background .12s ease, transform .08s ease;
        }
        .nav.small:hover { background: rgba(255,255,255,0.06); transform: scale(1.03); }

        .counter {
          color: #fff;
          font-size: 14px;
          min-width: 52px;
          text-align: center;
        }

        /* small accessibility helper */
        .sr-only { position: absolute !important; height: 1px; width: 1px; overflow: hidden; clip: rect(1px, 1px, 1px, 1px); white-space: nowrap; }

        /* Responsive tweaks */
        @media (max-width: 768px) {
          .top-large { height: 260px; }
          .thumb { height: 110px; }
          .modal-content { padding: 12px; }
          .close-btn { width: 36px; height: 36px; font-size: 16px; top: 8px; right: 8px; }
          .nav.small { width: 40px; height: 40px; font-size: 20px; }
          .controls { bottom: 12px; gap: 10px; padding: 6px 10px; }
        }
      `}</style>

        </div>
    )
}
